const DATATABLE_LOAD = "DATATABLE_LOAD";
const DATATABLE_LOAD_FAIL = "DATATABLE_LOAD_FAIL";
const DATATABLE_LOAD_SUCCESS = "DATATABLE_LOAD_SUCCESS";

const FILTER_POST = "FILTER_POST";
const FILTER_DELETE = "FILTER_DELETE";

export default function filter(
  state = {
    data: [],
    isLoading: true,
    hasErrored: false,
    message: "",
  },
  action,
) {
  switch (action.type) {
    case DATATABLE_LOAD: {
      return Object.assign({}, state, {
        isLoading: true,
        hasErrored: false,
      });
    }

    case DATATABLE_LOAD_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        message: action.error.message,
        hasErrored: true,
      });
    }

    case DATATABLE_LOAD_SUCCESS: {
      return Object.assign({}, state, {
        data: action.payload.data,
        isLoading: false,
        hasErrored: false,
      });
    }

    default:
      return state;
  }
}

export function getFilters() {
  return {
    type: DATATABLE_LOAD,
    payload: {
      request: {
        url: "Filter",
      },
    },
  };
}

export function addOrEditFilter(filter) {
  return {
    type: FILTER_POST,
    payload: {
      request: {
        url: "Filter",
        method: "POST",
        data: filter,
      },
      options: {
        onSuccess({ dispatch }) {
          dispatch(getFilters());
        },
      },
    },
  };
}

export function deleteFilter(id) {
  return {
    type: FILTER_DELETE,
    payload: {
      request: {
        url: "Filter/" + id,
        method: "DELETE",
      },
      options: {
        onSuccess({ dispatch }) {
          dispatch(getFilters());
        },
      },
    },
  };
}
